import _ from 'lodash';
import { useContext, useEffect } from 'react';
import { WrapperField } from '../../../../components/InputField/WrapperField';
import { isEmploymentStatusEmployed, shouldShowField, validateField } from '../../../../components/InputField/helper';
import { DialogContext } from '../../../../store/context/DialogContext';
import ButtonGroupNew from '../BusinessLiteForms/components/ButtonGroupNew';
import { IPLUS_WIZARD } from '../IPlushelper';
import { useTranslation } from '../../../../store/context/TranslationContext';
import { Col, Row } from 'reactstrap';
import { getVisibleWizardFieldOrder } from '../components/IndividualLite/helper';

const IPlusOccupationDetails = ({
    hideButtons,
    asLabel,
    data,
    handleUpdate,
    hasError,
    setHasError,
    cyclosFields,
    loading,
    errors,
    setErrors,
    iPlusFields,
    wizard,
    isForEDD,
    handlePrev,
    handleChange
}) => {
    const { showError } = useContext(DialogContext);
    const { t } = useTranslation();
    const isEmployed = isEmploymentStatusEmployed(data?.employmentStatus);

    useEffect(() => {
        const initialErrors = {};
        iPlusFields.forEach((field) => {
            if (
                field.required &&
                field?.wizard === wizard &&
                shouldShowField(data, field.showIf)
            ) {
                const value = _.get(data, field.field);
                if (value === undefined || value === null || value === "") {
                    if (value !== false && !_.get(errors, field.field)) {
                        _.set(initialErrors, field.field, field.errorTypes?.required || field.error || "This field is required.");
                    }
                }
            }
        });

        const shownErrors = {};
        iPlusFields.forEach((field) => {
            if (field?.wizard === wizard && shouldShowField(data, field.showIf)) {
                const value = _.get(data, field.field);
                const error = validateField(field, value, data);
                if (error) {
                    _.set(shownErrors, field.field, error);
                }
            }
        });

        setErrors(_.merge({}, shownErrors, initialErrors));
    }, [data, wizard, iPlusFields]);

    const checkNext = () => {
        const orderedFields = getVisibleWizardFieldOrder({ fields: iPlusFields, wizard, data });
        for (const fieldPath of orderedFields) {
            const fieldError = _.get(errors, fieldPath);
            if (fieldError) {
                setHasError(true);
                showError(fieldError);
                return false;
            }
        }
        setErrors({});
        return true;
    };

    const handleSubmit = () => {
        const isFormFieldValid = checkNext();
        if (isFormFieldValid) {
            setHasError(false);
            return handleUpdate({ nextStep: { wizard: IPLUS_WIZARD.IPlusAboutYou }, payload: data });
        } else {
            return;
        }
    };

    const handleUpdateFormData = (updatedData) => {
        handleChange(updatedData);
    }

    const handleErrors = (field, errorMsg) => {
        setErrors((prevErrors) => {
            const updatedErrors = _.cloneDeep(prevErrors);
            _.set(updatedErrors, field, errorMsg);
            return updatedErrors;
        })
    }

    return (
        <div className='row'>
            <Row>
                {isEmployed &&
                    <Col className='col-12 col-md-6'>
                        <WrapperField
                            disabled={asLabel}
                            jsonField={cyclosFields["nameOfEmployer"]}
                            dataObj={data}
                            onChange={handleUpdateFormData}
                            showError={hasError}
                            onError={(errorMsg) => handleErrors('nameOfEmployer', errorMsg)}
                            isForEDD={isForEDD}
                        />
                    </Col>
                }
                {isEmployed &&
                    <Col className='col-12 col-md-6'>
                        <WrapperField
                            disabled={asLabel}
                            jsonField={cyclosFields["position"]}
                            dataObj={data}
                            onChange={handleUpdateFormData}
                            showError={hasError}
                            onError={(errorMsg) => handleErrors('position', errorMsg)}
                            isForEDD={isForEDD}
                        />
                    </Col>
                }
            </Row>

            <Row>
                {isEmployed &&
                    <Col className='col-12 col-md-6'>
                        <WrapperField
                            disabled={asLabel}
                            jsonField={cyclosFields["startYear"]}
                            dataObj={data}
                            onChange={handleUpdateFormData}
                            showError={hasError}
                            onError={(errorMsg) => handleErrors('startYear', errorMsg)}
                            isForEDD={isForEDD}
                        />
                    </Col>
                }
                {isEmployed &&
                    <Col className='col-12 col-md-6'>
                        <WrapperField
                            disabled={asLabel}
                            jsonField={cyclosFields["countryOfLocationOfEmployer"]}
                            dataObj={data}
                            onChange={handleUpdateFormData}
                            showError={hasError}
                            className={'address-country-picker'}
                            onError={(errorMsg) => handleErrors('countryOfLocationOfEmployer', errorMsg)}
                            isForEDD={isForEDD}
                        />
                    </Col>
                }
            </Row>

            {isEmployed &&
                <WrapperField
                    disabled={asLabel}
                    jsonField={cyclosFields["natureOfBusinessActivityOfEmployer"]}
                    dataObj={data}
                    onChange={handleUpdateFormData}
                    showError={hasError}
                    onError={(errorMsg) => handleErrors('natureOfBusinessActivityOfEmployer', errorMsg)}
                    isForEDD={isForEDD}
                />
            }

            {data?.employmentStatus == "Self_Employed" &&
                <WrapperField
                    disabled={asLabel}
                    jsonField={cyclosFields["occupationServicesProducts"]}
                    dataObj={data}
                    onChange={handleUpdateFormData}
                    showError={hasError}
                    onError={(errorMsg) => handleErrors('occupationServicesProducts', errorMsg)}
                    isForEDD={isForEDD}
                />
            }
            <Row>
                {data?.employmentStatus == "Self_Employed" &&
                    <Col className='col-12 col-md-6'>
                        <WrapperField
                            disabled={asLabel}
                            jsonField={cyclosFields["numberEmployeesWorkForYou"]}
                            dataObj={data}
                            onChange={handleUpdateFormData}
                            showError={hasError}
                            onError={(errorMsg) => handleErrors('numberEmployeesWorkForYou', errorMsg)}
                            isForEDD={isForEDD}
                        />
                    </Col>
                }
                {data?.employmentStatus == "Self_Employed" &&
                    <Col className='col-12 col-md-6'>
                        <WrapperField
                            disabled={asLabel}
                            jsonField={cyclosFields["numberEmployeesIndependent"]}
                            dataObj={data}
                            onChange={handleUpdateFormData}
                            showError={hasError}
                            onError={(errorMsg) => handleErrors('numberEmployeesIndependent', errorMsg)}
                            isForEDD={isForEDD}
                        />
                    </Col>
                }

            </Row>

            <Row>
                {data?.employmentStatus == "Self_Employed" &&
                    <Col className='col-12 col-md-6'>
                        <WrapperField
                            disabled={asLabel}
                            jsonField={cyclosFields["soleProprietorTradeName"]}
                            dataObj={data}
                            onChange={handleUpdateFormData}
                            showError={hasError}
                            onError={(errorMsg) => handleErrors('soleProprietorTradeName', errorMsg)}
                            isForEDD={isForEDD}
                        />
                    </Col>
                }
                {data?.employmentStatus == "Self_Employed" &&
                    <Col className='col-12 col-md-6'>
                        <WrapperField
                            disabled={asLabel}
                            jsonField={cyclosFields["countriesWhereYouProvideServicesProducts"]}
                            dataObj={data}
                            onChange={handleUpdateFormData}
                            showError={hasError}
                            className={'address-country-picker'}
                            onError={(errorMsg) => handleErrors('countriesWhereYouProvideServicesProducts', errorMsg)}
                            isForEDD={isForEDD}
                        />
                    </Col>
                }
            </Row>

            {data?.employmentStatus == "Self_Employed" &&
                <WrapperField
                    disabled={asLabel}
                    jsonField={cyclosFields["mainCustomers"]}
                    dataObj={data}
                    onChange={handleUpdateFormData}
                    showError={hasError}
                    onError={(errorMsg) => handleErrors('mainCustomers', errorMsg)}
                    isForEDD={isForEDD}
                />
            }
            {data?.employmentStatus == "Unemployed" &&
                <WrapperField
                    disabled={asLabel}
                    jsonField={cyclosFields["explainHowYouDeriveIncome"]}
                    dataObj={data}
                    onChange={handleUpdateFormData}
                    showError={hasError}
                    onError={(errorMsg) => handleErrors('explainHowYouDeriveIncome', errorMsg)}
                    isForEDD={isForEDD}
                />
            }

            {["Unemployed", "Retired"]?.includes(data?.employmentStatus) &&
                <WrapperField
                    disabled={asLabel}
                    jsonField={cyclosFields["nameOfYourLastEmployer"]}
                    dataObj={data}
                    onChange={handleUpdateFormData}
                    showError={hasError}
                    onError={(errorMsg) => handleErrors('nameOfYourLastEmployer', errorMsg)}
                    isForEDD={isForEDD}
                />
            }

            <Row>
                {["Unemployed", "Retired"]?.includes(data?.employmentStatus) &&
                    <Col className='col-12 col-md-6'>
                        <WrapperField
                            disabled={asLabel}
                            jsonField={cyclosFields["startYearOfLastEmployment"]}
                            dataObj={data}
                            onChange={handleUpdateFormData}
                            showError={hasError}
                            onError={(errorMsg) => handleErrors('startYearOfLastEmployment', errorMsg)}
                            isForEDD={isForEDD}
                        />
                    </Col>
                }
                {["Unemployed", "Retired"]?.includes(data?.employmentStatus) &&
                    <Col className='col-12 col-md-6'>
                        <WrapperField
                            disabled={asLabel}
                            jsonField={cyclosFields["endYearOfLastEmployment"]}
                            dataObj={data}
                            onChange={handleUpdateFormData}
                            showError={hasError}
                            onError={(errorMsg) => handleErrors('endYearOfLastEmployment', errorMsg)}
                            isForEDD={isForEDD}
                        />
                    </Col>
                }
            </Row>

            <Row>
                {["Unemployed", "Retired"]?.includes(data?.employmentStatus) &&
                    <Col className='col-12 col-md-6'>
                        <WrapperField
                            disabled={asLabel}
                            jsonField={cyclosFields["lastOccupiedPosition"]}
                            dataObj={data}
                            onChange={handleUpdateFormData}
                            showError={hasError}
                            onError={(errorMsg) => handleErrors('lastOccupiedPosition', errorMsg)}
                            isForEDD={isForEDD}
                        />
                    </Col>
                }
                {["Unemployed", "Retired"]?.includes(data?.employmentStatus) &&
                    <Col className='col-12 col-md-6'>
                        <WrapperField
                            disabled={asLabel}
                            jsonField={cyclosFields["countryOfLocationYourFormerEmployer"]}
                            dataObj={data}
                            onChange={handleUpdateFormData}
                            showError={hasError}
                            className={'address-country-picker'}
                            onError={(errorMsg) => handleErrors('countryOfLocationYourFormerEmployer', errorMsg)}
                            isForEDD={isForEDD}
                        />
                    </Col>
                }
            </Row>

            <div className='mt-4'>
                <ButtonGroupNew
                    onNextClick={handleSubmit}
                    onBackClick={() => { handlePrev() }}
                    step={2}
                    hideSubmitButton={hideButtons}
                    showPageNum={false}
                    pageNum={2}
                    asLabel={false}
                    loading={loading}
                />
            </div>
        </div>
    );
};

export default IPlusOccupationDetails;
